export default __webpack_public_path__ + "static/media/javascript.5648ae0a.jpg";